var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"/globe/index.html","title":_vm.$t("Self Biography Globe"),"frameborder":"0","allowtransparency":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }